import { RouteObject } from "react-router-dom";
import { AiSourceViewerPage } from "src/routes/libraries/plan-package-v2/ai-sources/AiSourceViewerPage";
import { CreatePlanPackagePage } from "src/routes/libraries/plan-package-v2/create/CreatePlanPackagePage";
import { PlanPackagePageV2 } from "src/routes/libraries/plan-package-v2/PlanPackagePageV2";
import { PlanPackageVersionHistoryPage } from "src/routes/libraries/plan-package-v2/version-history/PlanPackageVersionHistoryPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { WorkflowPageLayout } from "src/routing/components/layouts/WorkflowPageLayout";
import * as planPackagesPaths from "src/routing/domains/libraries/plan-packages/planPackagesPaths";

/**
 * `/libraries/plan-packages/*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `BeamNavbarLayout` → page.
 * Exception: the AI source viewer, is full-bleed and branches off as `AppShell` → `WorkflowPageLayout` → page and registered
 *  first to keep it clear of the details page's `*` splat.
 *
 * The details page mounts on both the bare details URL (shown as the Overview tab) and a `*` splat so Beam's
 * route tabs can match the tab segments. When the `PLAN_PACKAGES_V2` flag is off, the details and create pages
 * redirect to their legacy `/libraries/plan/*` equivalents. The version history page is not flagged, so it can be
 * reached from both plan pages.
 *
 * TODO: update this description once the feature flag and legacy pages are removed.
 */
export const planPackagesRoute: RouteObject = {
  path: "/libraries/plan-packages",
  Component: AppShell,
  children: [
    {
      Component: WorkflowPageLayout,
      children: [{ path: planPackagesPaths.planPackageAiSourcesRoute.path, Component: AiSourceViewerPage }],
    },
    {
      Component: BeamNavbarLayout,
      children: [
        { path: planPackagesPaths.planPackageCreateRoute.path, Component: CreatePlanPackagePage },
        { path: planPackagesPaths.planPackageRoute.path, Component: PlanPackagePageV2 },
        { path: planPackagesPaths.planPackageVersionHistoryRoute.path, Component: PlanPackageVersionHistoryPage },
        { path: `${planPackagesPaths.planPackageRoute.path}/*`, Component: PlanPackagePageV2 },
      ],
    },
  ],
};
